<div class="modal-main-wrapper">
    <div class="close-container">
        <div class="img-container">
            <img src="../../../assets/icons/Close.svg"  (click)="stay()">
        </div>        
    </div>
    <div class="content-wrapper">
        <img src="../../../assets/icons/status-icon-confirmation.svg" alt="confirm?"  class="icon"/>
        <div class="message"   [innerHtml]="data.text"></div>
    </div>
    <footer>
    <div class="button-wrapper">
        <button id="no-button-confirm-popup" class="action-btn white-text danger cancelBtn" (click)="calcelUpload()">{{"cancelPatchUploadConfirm"  | transloco}}</button>
        <button id="confirm-buttom-confirm-popup" class="action-btn white-text" (click)="stay()">{{"No"  | transloco}}</button>
    </div>
</footer>
</div>